import React from "react"


const About = () => {
 
    return (
    <div className="wrapper">
    <h1>Une brève description des objectifs de l'Application</h1>
    React is a JavaScript library for building user interfaces.
      <ul>
      <li> React Router,</li>
      <li> React PropTypes,</li>
      <li> React Bootstrap,</li>
      <li> React Hooks "cycle de vie du composant",</li>
      <li> Hooks: useState / useContext / useRef ...</li>
      <li> Echanges entre composants,</li>
      <li> Fetch Data from API with useEffect,</li>
      <li> API: <br/>
      https://dog.ceo/api/<br/>
      https://jikan1.p.rapidapi.com/</li>
      </ul>
      <img src={process.env.PUBLIC_URL + '/logo192.png'} alt=""></img>
    </div>

    )
  }
  
export default About